import Page2FA from "./container";

export default Page2FA;
